import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IGetAchMessagingResponse) {
    (function(AchBannerSurface) {
        AchBannerSurface["ACH_BANNER_SURFACE_UNKNOWN"] = "ACH_BANNER_SURFACE_UNKNOWN";
        AchBannerSurface["ORDERS"] = "ORDERS";
        AchBannerSurface["POST_ORDERS"] = "POST_ORDERS";
        AchBannerSurface["INVOICES"] = "INVOICES";
        AchBannerSurface["ACCOUNT_SETTINGS"] = "ACCOUNT_SETTINGS";
    })(IGetAchMessagingResponse.AchBannerSurface || (IGetAchMessagingResponse.AchBannerSurface = {}));
    (function(AchOfferType) {
        AchOfferType["ACH_OFFER_TYPE_UNKNOWN"] = "ACH_OFFER_TYPE_UNKNOWN";
        AchOfferType["PROACTIVE_LIMIT_INCREASE"] = "PROACTIVE_LIMIT_INCREASE";
        /**
     * Requires linking ACH to claim terms offer
     */ AchOfferType["TERMS_PRE_APPROVAL_ACH_LINK"] = "TERMS_PRE_APPROVAL_ACH_LINK";
        AchOfferType["TERMS_PRE_APPROVAL"] = "TERMS_PRE_APPROVAL";
    })(IGetAchMessagingResponse.AchOfferType || (IGetAchMessagingResponse.AchOfferType = {}));
    (function(IBannerData) {
        IBannerData.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGetAchMessagingResponse.IBannerData || (IGetAchMessagingResponse.IBannerData = {}));
    IGetAchMessagingResponse.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IGetAchMessagingResponse || (IGetAchMessagingResponse = {}));
export var IGetAchMessagingResponse;
